export const applySystemReplacements = (url, {
  activeAccountId,
  subscriptionKey,
  userId,
  resourceType,
}) => {
  if (activeAccountId) {
    url = url
      .replace("{ActiveAccountID}", activeAccountId)
      .replace("{ActiveAccountId}", activeAccountId)
      .replace("{accountId}", activeAccountId)
      .replace("{activeAccountId}", activeAccountId);
  }

  if (subscriptionKey) {
    url = url.replace("{subscriptionKey}", subscriptionKey);
  }

  if (userId) {
    url = url.replace("{userId}", userId);
  }

  if (url.includes("{ResourceType}")) {
    if (!resourceType) {
      throw new Error("ResourceType is required for this dropdown request.");
    }
    url = url.replace(/\{ResourceType\}/g, encodeURIComponent(resourceType));
  }

  return url;
};

export const normalizeValueLabel = (value, label) => {
  if (value && typeof value === "object" && "value" in value) {
    return {
      value: value.value,
      label: value.label ?? label ?? value.value,
    };
  }

  return {
    value,
    label: label ?? value,
  };
};

export const formatPrice = (value, decimals = 2) => {
  if (value === null || value === undefined) return "N/A";
  return `$${Number(value).toFixed(decimals)}`;
};

export const getDependentFields = (formConfig, fieldName) =>
  formConfig.filter((field) =>
    field.parentField?.split(",").map((parent) => parent.trim()).includes(fieldName)
  );

export const renderSafeText = (value) => {
  if (value == null) return "";
  if (typeof value === "object") {
    return value.label ?? value.text ?? value.value ?? "";
  }
  return String(value);
};

export const isSystemParentReady = ({
  parent,
  subscriptionKey,
  activeAccountId,
  userId,
}) => {
  if (parent === "subscriptionKey") return Boolean(subscriptionKey);
  if (parent === "accountId" || parent === "ActiveAccountID") {
    return Boolean(activeAccountId);
  }
  if (parent === "userId") return Boolean(userId);
  return true;
};

export const isFormParentReady = (formValues, parent) =>
  Boolean(formValues[parent]?.value);

export const updateFieldVisibility = (setFormConfig, fieldName, isDisplay) => {
  setFormConfig((prev) => {
    const field = prev.find((item) => item.fieldName === fieldName);
    if (field && field.isDisplay === isDisplay) {
      return prev;
    }

    return prev.map((item) =>
      item.fieldName === fieldName ? { ...item, isDisplay } : item
    );
  });
};

export const getOptionLabelGeneric = (option) => {
  if (option == null) return "";
  if (typeof option === "string") return option;
  return option.text ?? option.label ?? option.value ?? "";
};

export const areParentsReady = ({
  field,
  formValues,
  subscriptionKey,
  activeAccountId,
  userId,
}) => {
  if (!field.parentField) return true;

  const parents = field.parentField.split(",").map((parent) => parent.trim());

  for (const parent of parents) {
    const isSystem = [
      "subscriptionKey",
      "accountId",
      "ActiveAccountID",
      "userId",
    ].includes(parent);

    if (isSystem) {
      if (
        !isSystemParentReady({
          parent,
          subscriptionKey,
          activeAccountId,
          userId,
        })
      ) {
        return false;
      }
    } else if (!isFormParentReady(formValues, parent)) {
      return false;
    }
  }

  return true;
};

export const valEq = (left, right) => left?.toString() === right?.toString();
export const norm = (value) => (value ?? "").toString().toLowerCase();
export const labelOf = (option) => option.label ?? option.text ?? "";

export const matchOption = (options, target) => {
  if (!target || !Array.isArray(options)) return null;
  const normalizedTarget = norm(target);
  return options.find(
    (option) =>
      valEq(option.value, target) ||
      norm(labelOf(option)) === normalizedTarget ||
      norm(labelOf(option)).includes(normalizedTarget)
  );
};

export const isValidAlbRedirectUrl = (value) => {
  if (typeof value !== "string") return false;

  const normalizedValue = value.trim();
  if (!normalizedValue) return false;

  if (!/^https?:\/\//i.test(normalizedValue) || /\s/.test(normalizedValue)) {
    return false;
  }

  try {
    const parsedUrl = new URL(normalizedValue);
    const isHttpUrl =
      parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
    const hasValidHost =
      parsedUrl.hostname === "localhost" ||
      /^(\d{1,3}\.){3}\d{1,3}$/.test(parsedUrl.hostname) ||
      (parsedUrl.hostname.includes(".") &&
        parsedUrl.hostname
          .split(".")
          .every(
            (part) =>
              /^[a-zA-Z0-9-]+$/.test(part) &&
              !part.startsWith("-") &&
              !part.endsWith("-")
          ));

    return isHttpUrl && hasValidHost;
  } catch {
    return false;
  }
};
